import { NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  input,
  output
} from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';

import { SortPipe } from '@shared/pipes/sort.pipe';
import { Account } from '@stores/models/app/account';

@Component({
  selector: 'app-account-picker',
  templateUrl: './account-picker.component.html',
  styleUrls: ['./account-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MatMenuModule, NgClass, SortPipe]
})
export class AccountPickerComponent {
  readonly accounts = input<Account[]>([]);
  readonly selectedAccountId = input<string>();

  readonly selected = output<Account>();

  onAccountChange(account: Account): void {
    this.selected.emit(account);
  }
}
